import React from 'react'

import Mark from './Mark'

// The house footer — nodejavascript.com site standard, part 4.
//
// THREE LINES, in this order: brand · links · copyright. The copyright carries the FULL
// DOMAIN NAME, which makes it the second place the origin is stated in full (the <title> is
// the first).
//
// What it replaced was one line — "Created by nodejavascript.com" — with no mark, no site
// name, no policy link and no way to change a cookie answer. The one thing the rule exists for
// is that the family reads as one family, and this is the only part every page has.
//
// 🔴 THE BRAND LINE CARRIES THE LINK HOME AND THE LINKS LINE DOES NOT REPEAT IT. George,
// 19 September 2026: *"i like the top line, the second line remove nodejavascript between
// privacy and cookie settings"*.
//
// 🔴 NO "BACK TO TOP". George, same day: *"remeber this, to remove · back to top from
// footers"* — a control about the page rather than about the site.
const SiteFooter = () => {
  return (
    <footer className='dvs-footer'>
      <div className='dvs-footer-brand'>
        <span className='dvs-mark' aria-hidden='true'>
          <Mark />
        </span>
        <span>
          <b>sudoku-ml</b> · <a href='https://nodejavascript.com/'>nodejavascript.com</a>
        </span>
      </div>

      <p className='dvs-footer-links'>
        <a href='#privacy'>Privacy</a>
        {' · '}
        <button id='consentBtn' className='linkish' type='button'>
          Cookie settings
        </button>
      </p>

      <p className='dvs-footer-copy'>© 2026 sudoku-ml.nodejavascript.com. All rights reserved.</p>
    </footer>
  )
}

export default SiteFooter
